module.exports = __webpack_public_path__ + "img/NewsCenter_pic5.3cabc8c8.png";